var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/add/patient"}},[_vm._v("\n\tEnroll Patients\n\t"),_c('EnrollIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }